import { useParams, Outlet } from "react-router-dom";
import { DealHeader } from "@/components/deal-v2/DealHeader";

const DealV2Layout = () => {
  const { dealId } = useParams<{ dealId: string }>();
  return (
    <div className="min-h-full bg-background">
      <div className="px-4 sm:px-6 py-8 sm:py-12 max-w-5xl mx-auto space-y-6">
        {dealId && <DealHeader dealId={dealId} />}
        <Outlet />
      </div>
    </div>
  );
};

export default DealV2Layout;
